import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openItems, setOpenItems] = React.useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "What services does Mova Astro offer?",
      answer: "Mova Astro offers annual Kundali reading, career and finance reading, personality strengths reading, marriage and relationship reading, child strengths reading, name and numerology reading, instant insight reading, gemstone selection reading, property and assets reading, and complete life chart reading."
    },
    {
      question: "How do I book an astrology consultation on Mova Astro?",
      answer: "Choose a service, select a preferred slot (subject to availability), complete payment, and you will receive confirmation with session details. You can also contact support for booking assistance."
    },
    {
      question: "Do you offer online astrology consultations?",
      answer: "Yes. Mova Astro provides online astrology consultations so you can book and attend sessions from anywhere."
    },
    {
      question: "Do you accept payments in INR and USD?",
      answer: "Yes. Mova Astro accepts payments in INR and also supports international payments in select currencies including USD, subject to payment gateway availability."
    },
    {
      question: "Is my payment refundable after booking?",
      answer: "No. All payments made on Mova Astro are final and non-refundable once the booking is completed."
    },
    {
      question: "Can I cancel my consultation and get a refund?",
      answer: "No. Cancellations do not qualify for refunds. Payments are non-refundable after successful booking."
    },
    {
      question: "Can I reschedule my consultation session?",
      answer: "Yes. You can reschedule your session one time to any available slot within 7 calendar days of payment, subject to availability and rescheduling rules."
    },
    {
      question: "What is the rescheduling deadline for my booking?",
      answer: "Your rescheduled session must be completed within 7 calendar days from the date of payment. If not rescheduled within this period, the booking will be forfeited without refund."
    },
    {
      question: "What happens if I miss the consultation (no-show)?",
      answer: "If you miss your scheduled session without rescheduling within the allowed time, it will be treated as a no-show and the booking will be forfeited without refund."
    },
    {
      question: "How do I request a reschedule?",
      answer: "To reschedule, contact Mova Astro support with your booking details and preferred alternate slots. Rescheduling is subject to availability and must follow the policy timeline."
    },
    {
      question: "Are gemstone recommendations generic or chart-based?",
      answer: "Gemstone recommendations are provided based on your birth chart analysis. Mova Astro does not provide generic gemstone suggestions."
    },
    {
      question: "Is astrology guaranteed to produce specific results?",
      answer: "Astrology is interpretative and intended for guidance and self-understanding. Mova Astro does not guarantee specific outcomes or results."
    },
    {
      question: "How can I contact Mova Astro support?",
      answer: "You can contact Mova Astro support through the contact details provided on the website for booking assistance, rescheduling, or general queries."
    }
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <>
      <Navigation />
      
      <div className="min-h-screen bg-sand pt-32">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-serif text-indigoDeep mb-4">Frequently Asked Questions</h1>
            <p className="text-grayWarm text-lg">Find answers to common questions about our services and policies</p>
          </div>

          <div className="space-y-4">
            {faqData.map((item, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md border border-goldSoft/20">
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-goldSoft/10 transition-colors"
                >
                  <h3 className="text-lg font-semibold text-indigoDeep pr-4">{item.question}</h3>
                  {openItems[index] ? (
                    <ChevronUp className="w-5 h-5 text-goldSoft flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-goldSoft flex-shrink-0" />
                  )}
                </button>
                
                {openItems[index] && (
                  <div className="px-6 pb-4">
                    <p className="text-grayWarm leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-grayWarm mb-4">Still have questions?</p>
            <a
              href="/contact"
              className="inline-block px-6 py-3 bg-goldSoft text-indigoDeep font-semibold rounded-md hover:bg-goldHover transition-colors"
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default FAQ;